import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { MaxAppWidth } from '@ally/next-layout'
import { AriaLiveProvider } from '@ally/use-aria-live'

import { Auto } from '../components/Auto'
import { CardWorks } from '../components/CardWorks'

export const Router: React.FC = () => {
  // If your app requires authentication, you can do it like so...
  // This will store off the current route, wait for the user to login, then
  // redirect back here...
  // const { session } = useHostServices()
  // useEffect(() => session.requireAuth(), [])

  return (
    <MaxAppWidth py="md">
      <Switch>
        <Route path="/sso/credit-card/*">
          <AriaLiveProvider>
            <CardWorks />
          </AriaLiveProvider>
        </Route>
        <Route path="/sso/auto/*">
          <Auto />
        </Route>
        <Route path="/sso/*">
          <Redirect to="/error/404" />
        </Route>
      </Switch>
    </MaxAppWidth>
  )
}

export default Router
